module.exports = __webpack_public_path__ + "static/dfd-23f4f370048a3342eb4ca621db5f7a79.png";